module.exports = __webpack_public_path__ + "img/IMG_8473_P_L_Foamcore_MockedUp.107c9892.jpg";